import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import icubanner from "../../assets/images/icu_banner.png";
import "../nursingcare/NursingCare.css";
import Filter from "../../layout/Filter";
import SearchIcon from "@mui/icons-material/Search";
import TuneRoundedIcon from "@mui/icons-material/TuneRounded";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import NorthEastIcon from "@mui/icons-material/NorthEast";
import NursingcareData from "../../LabData/NursingcareData";
import Longterm from "../nursingcare/Longterm";
import { fetchAPI } from "../../utils/api";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import AddShoppingCartOutlinedIcon from "@mui/icons-material/AddShoppingCartOutlined";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HeadsetMicIcon from "@mui/icons-material/HeadsetMic";
import EventIcon from "@mui/icons-material/Event";
import Testimonial from "../../layout/Home/Testimonial";
import Review from "../../layout/Home/Review";
import physiotherapistimg1 from "../../assets/images/physiotherapist_img_1.png";
import physiotherapistimg2 from "../../assets/images/physiotherapist_img_2.png";
import physiotherapybanner from "../../assets/images/physiotherapy_banner_img.png";
import nursingbanner from "../../assets/images/nursing-banner.png";
import p2 from "../../assets/images/p2.png";
import PhysiotherapyServices from "../nursingcare/PhysiotherapyServices";
const steps = [
  {
    id: 1,
    title: "Book Online",
    desc: "Fill the form or call us",
  },
  {
    id: 2,
    title: "Assessment Call",
    desc: "Doctor reviews patient needs",
  },
  {
    id: 3,
    title: "Equipment Setup",
    desc: "Team arrives with all gear",
  },
  {
    id: 4,
    title: "Care Begins",
    desc: "Nurse starts 24/7 care",
  },
];

export default function Physiotherapy() {
  const [physioData, setPhysioData] = useState(NursingcareData);
  const [expanded, setExpanded] = useState({});
  const [open, setOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedShortTerm, setSelectedShortTerm] = useState([]);
  const [searchOpen, setSearchOpen] = useState(false);

  const [homeData, setHomeData] = useState({
    testimonials: [],
  });

  useEffect(() => {
    const saved = localStorage.getItem("selectedShortTerm");
    if (saved) {
      try {
        setSelectedShortTerm(JSON.parse(saved));
      } catch (e) {
        console.error("Failed to parse selectedShortTerm", e);
      }
    }
  }, []);

  const handleCheckboxChange = (service) => {
    setSelectedShortTerm((prev) => {
      const exists = prev.find((item) => item.id === service.id);
      let updated;
      if (exists) {
        updated = prev.filter((item) => item.id !== service.id);
      } else {
        updated = [...prev, service];
      }
      localStorage.setItem("selectedServicesCart", JSON.stringify(updated));
      localStorage.setItem("selectedShortTerm", JSON.stringify(updated));
      localStorage.setItem("activeCartType", "services");
      window.dispatchEvent(new Event("cartUpdated"));
      return updated;
    });
  };

  const filteredPhysioData = physioData
    .map((category) => {
      const services = Array.isArray(category.services)
        ? category.services
        : [];
      const matchedServices = services.filter((service) => {
        const serviceName =
          service && typeof service.name === "string" ? service.name : "";
        return serviceName.toLowerCase().includes(searchQuery.toLowerCase());
      });

      const categoryName =
        category && typeof category.servicesname === "string"
          ? category.servicesname
          : "";
      const isCategoryMatch = categoryName
        .toLowerCase()
        .includes(searchQuery.toLowerCase());
      const servicesToKeep = isCategoryMatch ? services : matchedServices;

      if (servicesToKeep.length > 0) {
        return {
          ...category,
          totalservices: `Total ${servicesToKeep.length} Service${servicesToKeep.length > 1 ? "s" : ""}`,
          services: servicesToKeep,
        };
      }
      return null;
    })
    .filter(Boolean);

  const [serviceDetail, setServiceDetail] = useState({
    title: "Physiotherapy",
    subtitle: "Professional physiotherapy care at your <span>Doorstep</span>",
    description:
      "All physiotherapists are background-verified, clinically trained, and matched to your patient's specific condition. Select services below to build your care plan.",
    image: physiotherapybanner,
  });

  useEffect(() => {
    fetchAPI("CaregiverController/services")
      .then((data) => {
        if (data.status === 200 && Array.isArray(data.result)) {
          const service = data.result.find((s) => parseInt(s.service_id) === 2);
          if (service) {
            setServiceDetail({
              title: service.service_title,
              subtitle: service.service_sub_title,
              description: service.service_description,
              image: service.service_image || physiotherapybanner,
            });
          }
        }
      })
      .catch((err) => {
        console.error("Error fetching service details:", err);
      });
  }, []);

  useEffect(() => {
    fetchAPI("CaregiverController/packages", {
      method: "POST",
      body: JSON.stringify({
        service_id: 2,
        service_type_id: 1,
      }),
    })
      .then((data) => {
        if (data.status === 200 && Array.isArray(data.result)) {
          const mapped = data.result.map((cat) => {
            return {
              id: parseInt(cat.package_category_id),
              servicesname: cat.package_category_title,
              totalservices: `Total ${cat.packages.length} Service${cat.packages.length > 1 ? "s" : ""}`,
              services: cat.packages.map((pkg) => {
                const priceVal = parseFloat(pkg.price);
                const salePriceVal = parseFloat(pkg.sale_price);
                let offerText = "Special Price";
                if (priceVal > 0 && salePriceVal > 0) {
                  const pct = Math.round(
                    ((priceVal - salePriceVal) / priceVal) * 100,
                  );
                  if (pct > 0) {
                    offerText = `${pct}% Off`;
                  }
                }
                return {
                  id: parseInt(pkg.package_id),
                  name: pkg.package_title,
                  duration: pkg.duration,
                  offer: offerText,
                  price: `₹${pkg.sale_price}`,
                  oldPrice: pkg.price ? `(₹${pkg.price})` : "",
                };
              }),
            };
          });
          setPhysioData(mapped);
        }
      })
      .catch((err) => {
        console.warn(
          "Failed to load short term packages, using static fallback",
          err,
        );
      });
  }, []);

  return (
    <>
      <Header />

      <div className="caregiver_services nurgincare_services physio-main-sec">
        <div className="physio-header-breadcrumb">
          <div className="container-fluid">
            <div className="row">
              <div className="col-xxl-6 col-xl-5 col-lg-4 col-md-4 col-12">
                <div className="caregiver_ser_title text-start">
                  <h1>
                    <span>Physiotherapy </span> At Home
                  </h1>
                  <p>
                    Professional physiotherapy at home with personalized
                    treatment by experienced physiotherapists.
                  </p>
                </div>
              </div>

              <div className="col-xxl-6 col-xl-7 col-lg-8 col-md-8 col-12">
                <div className="term-search-outer physio-serch-outer">
                  <div className="search-main-outer">
                    <div className="search_icon_animation">
                      <div className="search-box physio-serch">
                        <input
                          type="text"
                          placeholder="Search..."
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                        />

                        <button>
                          <SearchIcon />
                        </button>
                      </div>
                    </div>
                    <div className="search_sec_long">
                      <form onSubmit={(e) => e.preventDefault()}>
                        <input
                          type="text"
                          placeholder="Search Service...."
                          className="search_input_long"
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                        />
                        <button type="button" className="search_btn_long">
                          SEARCH
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid">
          <div className="inner_caregier_services">
            <div className="main_services_caregiver_sec">
              <div className="tabs_sec_services">
                <div className="longter-boxx">
                  {/* <Longterm serviceId={2} serviceTitle={serviceDetail.title} serviceDesc={serviceDetail.description} /> */}

                  <PhysiotherapyServices searchQuery={searchQuery} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="whychse caregiver_why_content">
        <div className="container-fluid">
          <div className="section_heading">
            <div className="content_part text-center col-lg-12  col-sm-12 col-12">
              <span className="short_title">Why Choose Us</span>
              <h2>
                Why Families Trust Our<span> Physiotherapy </span>Service
              </h2>
              <p>
                Receive professional physiotherapy at home from experienced
                physiotherapists who provide personalized rehabilitation
                programs focused on pain relief, mobility improvement, and
                faster recovery.
              </p>
            </div>
          </div>
          <div className="row g-3">
            <div className="col-lg-3 col-md-3 col-sm-12 col-12">
              <div className="boxes">
                <VerifiedUserOutlinedIcon />
                <h3>Experienced Physiotherapists</h3>
                <p>
                  Licensed physiotherapists deliver safe, effective, and
                  personalized rehabilitation using modern physiotherapy
                  techniques.
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-12 col-12">
              <div className="boxes">
                <LocalOfferOutlinedIcon />
                <h3>Customized Therapy Plans</h3>
                <p>
                  Individual treatment plans developed according to each
                  patient's medical condition, recovery goals, and physical
                  abilities.
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-12 col-12">
              <div className="boxes">
                <VerifiedUserOutlinedIcon />
                <h3>Affordable Physiotherapy Care</h3>
                <p>
                  Quality physiotherapy services with transparent pricing and
                  flexible treatment plans for short-term and long-term
                  rehabilitation.
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-12 col-12">
              <div className="boxes">
                <AddShoppingCartOutlinedIcon />
                <h3>Advanced Rehabilitation Support</h3>
                <p>
                  Professional physiotherapy focused on improving movement,
                  reducing pain, restoring strength, and enhancing overall
                  physical well-being.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="icu_content_section">
        <div className="container-fluid">
          <div className="about_us_first_sec">
            <div className="row">
              <div className="col-lg-5 col-md-5 col-12">
                <div className="img_and_text_about">
                  <div className="content_nursing_img">
                    <img src={physiotherapistimg1} alt="About" />
                  </div>
                </div>
              </div>
              <div className="col-lg-7 col-md-7 col-12">
                <div className="about_content">
                  <p className="title-about">CaresAtHome</p>
                  <h2 className="heading-about">
                    What Does <span>Physiotherapy </span> at Home Include?
                  </h2>
                  <p className="pera-about">
                    Professional physiotherapy at home helps patients regain
                    mobility, reduce pain, improve strength, and recover faster
                    in a comfortable home environment. Our experienced
                    physiotherapists assess each patient's condition and create
                    personalized rehabilitation programs using clinically proven
                    treatment techniques.
                  </p>
                  <p className="pera-about">
                    Our physiotherapy service in Jaipur includes orthopedic
                    physiotherapy, neurological rehabilitation, post-operative
                    rehabilitation, sports injury treatment, stroke
                    rehabilitation, arthritis management, back and neck pain
                    treatment, balance training, mobility improvement, and
                    strengthening exercises.
                  </p>
                  <div className="about_bullet_point">
                    <div className="about_point-self">
                      <CheckCircleIcon />
                      <div className="head_pera_about">
                        <h4>Personalized Rehabilitation Programs</h4>
                        <p>
                          Every treatment session is customized to improve
                          mobility, strength, flexibility, and recovery based on
                          each patient's individual healthcare needs.
                        </p>
                      </div>
                    </div>

                    <div className="about_point-self">
                      <CheckCircleIcon />
                      <div className="head_pera_about">
                        <h4>Continuous Progress Monitoring</h4>
                        <p>
                          Regular assessments, exercise progression, pain
                          management, and recovery tracking ensure effective
                          treatment outcomes and long-term physical improvement.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="about_us_first_sec nursing_care_c2">
            <div className="row">
              <div className="col-lg-7 col-md-7 col-12">
                <div className="about_content">
                  <p className="title-about">CaresAtHome</p>
                  <h2 className="heading-about">
                    Benefits of Choosing <span>Physiotherapy</span> at Home
                  </h2>
                  <p className="pera-about">
                    Choosing a professional physiotherapy at home service allows
                    patients to receive expert rehabilitation in a comfortable
                    environment while avoiding unnecessary travel. Personalized
                    treatment sessions promote faster recovery, improve
                    mobility, and help patients return to their daily activities
                    with confidence.
                  </p>
                  <div className="about_bullet_point">
                    <ul className="bullet_points_care about_point-self">
                      <li>
                        <CheckCircleIcon /> Faster Recovery at Home
                      </li>
                      <li>
                        <CheckCircleIcon /> Improved Mobility & Flexibility{" "}
                      </li>
                      <li>
                        <CheckCircleIcon /> Reduced Pain & Muscle Stiffness
                      </li>
                      <li>
                        <CheckCircleIcon /> Personalized One-to-One Treatment
                      </li>
                      <li>
                        <CheckCircleIcon /> Better Balance & Coordination
                      </li>
                      <li>
                        <CheckCircleIcon /> Enhanced Strength & Endurance
                      </li>
                      <li>
                        <CheckCircleIcon /> Convenient Home-Based Therapy
                      </li>
                      <li>
                        <CheckCircleIcon /> Professional Rehabilitation Support
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-5 col-md-5 col-12">
                <div className="img_and_text_about">
                  <div className="content_nursing_img">
                    <img src={p2} alt="About" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Testimonial testimonials={homeData.testimonials} />

      <Footer />
    </>
  );
}
